import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import confirm from 'components/confirm';
import PhotoUploader from 'components/photos/photo_uploader';
import UploadButton from 'components/photos/upload_button';
import FloorPlanRow from 'components/floor_plan/floor_plan_row';

const UPLOAD_FLOOR_TEXT = 'Drag or click here to add a plan';

export default function FloorPlan({ floorPlan, osSection, onChange }) {
  const dropzoneRef = useRef(null);

  const removePlan = () => {
    const newFloorPlan = {
      ...floorPlan,
      _destroy: true,
    };

    onChange(newFloorPlan);
  };

  const deletePlan = (e) => {
    e.preventDefault();
    removePlan();
  };

  const confirmDeletePlan = async () => {
    try {
      await confirm('This floor plan is removed from the space when you save.', {
        buttonLabel: 'Delete Floor Plan',
        buttonStyle: 'danger',
        title: 'Delete this floor plan?'
      });
    } catch (error) {
      if (error) throw error;
      return;
    }

    removePlan();
  };

  const replacePlan = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open();
    }
  };

  const handleUpload = (data) => {
    const newFloorPlan = {
      ...floorPlan,
      thumbnailUrl: data.url,
      uploadId: data.id,
      uploaded: true,
      _destroy: false
    };

    onChange(newFloorPlan);
  };

  const isRowVisible = !!floorPlan && !floorPlan._destroy;

  if (osSection) {
    return osSection(
      <UploadButton label={isRowVisible ? 'Replace' : 'Add'} onUpload={handleUpload} />,
      isRowVisible && (
        <FloorPlanRow floorPlan={floorPlan} osCard onDelete={confirmDeletePlan} onReplace={replacePlan} />
      ),
      isRowVisible
    );
  }

  return (
    <React.Fragment>
      {/* PhotoUploader needs to be rendered always, otherwise the "Replace Plan" button and the ref will not work
      because the component doesn't exists. */}
      <div className={isRowVisible ? 'hidden' : ''}>
        <PhotoUploader forwardedRef={dropzoneRef} uploadCopy={UPLOAD_FLOOR_TEXT} onUpload={handleUpload} />
      </div>
      {isRowVisible && (
        <FloorPlanRow floorPlan={floorPlan} onDelete={deletePlan} onReplace={replacePlan} />
      )}
    </React.Fragment>
  );
}

FloorPlan.propTypes = {
  floorPlan: PropTypes.shape({
    id: PropTypes.number,
    uploadId: PropTypes.number,
    thumbnailUrl: PropTypes.string,
    _destroy: PropTypes.bool
  }),
  osSection: PropTypes.func,
  onChange: PropTypes.func.isRequired
};
